import React, { useEffect, useState } from "react";
import JoinButton from "./JoinButton";

const SuperCheckoutJoinButton = ({
  channelDetails,
  userChannelDetail,
  ctaButton,
  fullWidth,
  isCreator,
  isCoCreator,
  isLoading,
  isDisabled,
  couponState,
  couponDiscount,
  channelFee,
  userData,
  customConfig
}) => {

  const [isPaymentSuccess, setIsPaymentSuccess] = useState(false);
  const [isCheckoutOpened, setIsCheckoutOpened] = useState(false);

  const checkoutSettings = customConfig?.settings?.checkout;

  useEffect(() => {
    if (isPaymentSuccess && !isCheckoutOpened) {
      location.reload();
    }
  }, [isPaymentSuccess, isCheckoutOpened]);

  const handleOnPaymentSuccess = (...args) => {
    console.log("web - payment success...", args);
    setIsPaymentSuccess(true);
  };

  const handleOnClose = (...args) => {
    console.log("web - closed payment modal...", args);
    setIsCheckoutOpened(false);
  };

  function openCheckout() {
    const options = {
      entity_type: "channel",
      entity_id: channelDetails.uid,
      on_payment_success: handleOnPaymentSuccess,
      on_close: handleOnClose,

      notes: {},
    };

    if (window.qoohoo) {
      const checkout = new qoohoo(options);
      checkout.open();
      setIsCheckoutOpened(true);
    }
  }

  return (
    <JoinButton
      channelDetails={channelDetails}
      userChannelDetail={userChannelDetail}
      ctaButton={ctaButton}
      fullWidth={fullWidth}
      isCreator={isCreator}
      isCoCreator={isCoCreator}
      isLoading={isLoading}
      isDisabled={isDisabled}
      couponState={couponState}
      couponDiscount={couponDiscount}
      channelFee={channelFee}
      handleButtonClick={openCheckout}
    />
  );
};

export default SuperCheckoutJoinButton;
